<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'activities.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="activitiesGrid" :preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import States from '@/components/Lists.js'
import router from '@/router'

export default {
  name: 'ActivitiesGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'id': {
          type: 'number',
          editable: false
        }
      },
      url: 'activities',
      preload: [{
        api: 'familymembertypes/lst',
        field: 'family_member_type_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px',
        editable: false
      },
      {
        field: 'name',
        title: 'Nome',
        width: '180px'
      },
      {
        field: 'state',
        title: 'Estado',
        width: '180px',
        values: States.states
      },
      {
        field: 'family_member_type_id',
        title: 'Escalão',
        width: '180px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      if (this.$auth.check('activities.edit')) {
        var route = router.resolve({
          name: 'activities.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      } else if (this.$auth.check('activities.view')) {
        var route = router.resolve({
          name: 'activities.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
